export default "__VITE_ASSET__lINR359M__"